// extracted by mini-css-extract-plugin
module.exports = {"compose":"ComposeButton_compose__1hjL_"};